import { getSavedLocale, localeLabels, setLocale, supportedLocales } from '@/i18n';
import BaseService from '@/services/BaseService';
import { useMixpanelService } from './MixpanelService';

class I18nService extends BaseService {

	readonly localeOptions = supportedLocales.map(loc => ({
		label: `${localeLabels[loc].flag} ${localeLabels[loc].label}`,
		value: loc,
		flag: localeLabels[loc].flag,
	}));

	setLocale (locale: SupportedLocale, reload = false) {
		useMixpanelService().track('click.i18n.change', { lang_slug: locale });
		setLocale(locale, reload);
	}

	getLocale () {
		return this.localeOptions.find(o => o.value === getSavedLocale()) ?? this.localeOptions[0];
	}

}

const i18nServiceSingleton = new I18nService();

export function useI18nService () {
	return i18nServiceSingleton;
}
